export default "__VITE_ASSET__QNoAP7GH__"